import { useEffect } from 'react'

import window from './window'

const collegeProfileUrl = '/colleges/[0-9]+'
const profileUrl = 'student/profile'
const BLACKLIST = [collegeProfileUrl, profileUrl].join('|')

const isBlacklisted = (pathname) => {
  return RegExp(BLACKLIST).test(pathname)
}

export const useScrollResetter = (pathname) => {
  useEffect(() => {
    if (!isBlacklisted(pathname)) {
      window.scrollTo(0, 0)
    }
  }, [pathname])
}
